import type {ISonuc} from "@/model/sonuc.ts";

export interface ISonucDto {
    ds: number;
    ys: number;
    bs: number;
    p: number;
    s: number;
    bsz: string;
    bz: string;
    ts: number;
    km: boolean
    us: number;
    is: number;
    ics: number;
    os: number;
    dk: boolean;
    um: string;
}

export function mapSonucFromDTO(dto: ISonucDto): ISonuc {
    return {
        dogru_sayisi: dto.ds,
        yanlis_sayisi: dto.ys,
        bos_sayisi: dto.bs,
        puan: dto.p,
        siralama: dto.s,
        baslama_zamani: dto.bsz,
        bitirme_zamani: dto.bz,
        toplam_sure: dto.ts,
        katildi_mi: dto.km,
        ulke_siralama: dto.us,
        il_siralama: dto.is,
        ilce_siralama: dto.ics,
        okul_siralama: dto.os,
        diskalifiye: dto.dk,
        uyari_metni: dto.um
    };
}
